import type {
  ShortCircuitScenarioResults,
  ShortCircuitScenarioElementCalculation
} from '../../..';
import { FaultsProperties } from '../../../derived-state/gridElementsDetailsByCalculationType/shortCircuit/ShortCircuitProperty';
import type { FunctionalGridElementTypes } from '../../../grid/FunctionalGrid';
import type { ForFaultsEvaluation } from '../ForFaultsEvaluation';
import { evaluateFaultCurrent } from './evaluateFaultCurrent';

export class GridElementsSummaryEvaluation {
  constructor(private readonly faultsProperties: FaultsProperties) {}

  static fromScenarios(
    scenarios: ShortCircuitScenarioResults[],
    objectType: FunctionalGridElementTypes
  ) {
    const faultProperties =
      FaultsProperties.fromManyScenarios(scenarios).for(objectType);
    return new GridElementsSummaryEvaluation(faultProperties);
  }

  static fromResults(
    results: ShortCircuitScenarioElementCalculation[],
    objectType: FunctionalGridElementTypes
  ) {
    const faultProperties =
      FaultsProperties.fromResults(results).for(objectType);
    return new GridElementsSummaryEvaluation(faultProperties);
  }

  evaluate = (evaluationEngine: ForFaultsEvaluation) => {
    return {
      phase1Min: evaluateFaultCurrent(
        this.faultsProperties.from1PhaseToGroundMin(),
        evaluationEngine.evaluate1PhaseToGroundMin
      ),
      phase1Max: evaluateFaultCurrent(
        this.faultsProperties.from1PhaseToGroundMax(),
        evaluationEngine.evaluate1PhaseToGroundMax
      ),
      phase2Min: evaluateFaultCurrent(
        this.faultsProperties.from2PhasesMin(),
        evaluationEngine.evaluate2PhasesMin
      ),
      phase3Max: evaluateFaultCurrent(
        this.faultsProperties.from3PhasesMax(),
        evaluationEngine.evaluate3PhasesMax
      )
    };
  };
}
